import { isToday, isTomorrow, parse, isWeekend as isWeekend$1, addDays } from 'date-fns';
import { formatDateTime } from './format-date.js';

function futureUnixTimestamp(days) {
  // Get the current date
  const date = new Date();
  // Add the number of days to the current date
  date.setDate(date.getDate() + days);
  // Return the Unix timestamp in seconds
  return Math.floor(date.getTime() / 1000);
}
function getDescriptiveDay(dateTime) {
  let descriptiveDay = '';
  if (isToday(dateTime)) {
    descriptiveDay += 'Today, ';
  }
  if (isTomorrow(dateTime)) {
    descriptiveDay += 'Tomorrow, ';
  }
  descriptiveDay += formatDateTime({
    dateTime,
    format: 'iiii, MMMM d'
  });
  return descriptiveDay;
}
// Gets Monday of the previous week
function getPreviousWeekMonday() {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const difference = today.getDate() - dayOfWeek - 6;
  const monday = new Date(today.setDate(difference));
  monday.setHours(0, 0, 0, 0);
  return monday;
}
// Gets Sunday of the previous week
function getPreviousWeekSunday() {
  const previousMonday = getPreviousWeekMonday();
  const sunday = new Date(previousMonday);
  sunday.setDate(previousMonday.getDate() + 6);
  sunday.setHours(23, 59, 59, 999);
  return sunday;
}
function getNumberOfDaysFromTimeStamp(timeStamp) {
  if (!timeStamp) {
    return 0;
  }
  const date = new Date(timeStamp);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
/**
 * Check if a string date is weekend day
 * @param dateString 'MM/dd/yyyy'
 * @returns
 */
function isWeekend(dateString) {
  const format = 'MM/dd/yyyy';
  const parsedDate = parse(dateString, format, new Date());
  return isWeekend$1(parsedDate);
}
/**
 * Add days to a date string
 * @param dateStr 'MM/dd/yyyy'
 * @param days number of days to add
 * @returns 'MM/dd/yyyy'
 * @example addDaysHelper('01/01/2021', 1) => '01/02/2021'
 */
function addDaysHelper(dateStr, days) {
  // Parse the input date string
  const parsedDate = parse(dateStr, 'MM/dd/yyyy', new Date());
  // Add the specified number of days
  const newDate = addDays(parsedDate, days);
  // Format the new date back to 'MM/DD/yyyy'
  return newDate.toLocaleDateString('en-US');
}

export { addDaysHelper, futureUnixTimestamp, getDescriptiveDay, getNumberOfDaysFromTimeStamp, getPreviousWeekMonday, getPreviousWeekSunday, isWeekend };
